// @flow
import SubaccountReport from './SubaccountReport'
export default () => ({
  path: 'subaccount-report',
  element: <SubaccountReport />,
})